// <неразрывный пробел><среднее тире><обычный пробел>
export const normalDelimiter = '\u00A0\u2013 ';

// <неразрывный пробел><среднее тире><неразрывный пробел>
export const normalNonBreakingDelimiter = '\u00A0\u2013\u00A0';

// <тонкий неразрывный пробел><среднее тире><тонкий неразрывный пробел>
export const narrowNonBreakingDelimiter = '\u202F\u2013\u202F';
